/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: theme.spacing(50)
    },
    editableTextfield: {
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100% !important',
        backgroundColor: '#F7F8FB',
        transition: 'border 0.3s',
        borderRadius: `${theme.spacing(0.5)}px !important`,
        border: '1px solid #ffffff',
        minHeight: theme.spacing(5),
        overflow: 'hidden',
        '&:hover, &:active': {
            border: '1px solid #5567D5',
            backgroundColor: '#FFFFFF',
            cursor: 'pointer',
            overflow: 'auto',
        },
        '& .MuiInputBase-root': {
            width: '100% !important',
            lineHeight: 2,
            padding: 0,
            marginTop: theme.spacing(-0.4)
        },
        '& .MuiFilledInput-root': {
            width: '100% !important',
            borderRadius: `${theme.spacing(0.5)}px !important`,
            backgroundColor: '#F7F8FB',
            paddingLeft: 10,
            fontSize: 13,
            color: '#8D91A3',
            '&:hover': {
                border: '1px solid #5567D5',
                backgroundColor: '#FFFFFF',
            },
        },
        '& .MuiInputBase-input': {
            padding: '3px 0 0',
        },
        '& .MuiFilledInput-input': {
            paddingTop: theme.spacing(1.75),
            paddingBottom: theme.spacing(1.75),
        },
        '& .MuiFilledInput-underline:after': {
            display: 'none',
        },
    },
    editIcon: {
        marginTop: theme.spacing(0.2),
    },
}));

export default useStyles;
